import adminOrCollaboratorDelete from './admin-or-collaborator-delete'
import supervisorOrManagerDelete from './supervisor-or-manager-delete'
import brokerDelete from './broker-delete'
import dinamicDelete from './dinamic-delete'


export {
    adminOrCollaboratorDelete,
    supervisorOrManagerDelete,
    brokerDelete,
    dinamicDelete
}